import { Component, computed, Inject } from '@angular/core';
import { IValidateReferralStatusData } from '../../../../shared/types/validation-status-modal-data.interface';
import { Router } from '@angular/router';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AddReferralStatuses } from '../core/types/add-referral-statuses.enum';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { KorviuButtonComponent } from '../../../../shared/components/korviu-button/korviu-button.component';
import { UserTypeClasses, UserTypes } from '../../../../shared/types/user.model';
import { ReferralModalFacade } from '../../services/referral-modal.facade';

@Component({
  selector: 'app-verify-referral-modal',
  standalone: true,
  imports: [TranslateModule, NzModalModule, NzIconModule, KorviuButtonComponent],
  templateUrl: './verify-referral-modal.component.html',
  styleUrl: './verify-referral-modal.component.scss'
})
export class VerifyReferralModalComponent {
  public AddReferralStatuses: typeof AddReferralStatuses = AddReferralStatuses;
  public UserTypes: typeof UserTypes = UserTypes;

  public get isStatusInvited(): boolean {
    return this.data.status === AddReferralStatuses.INVITED;
  }
  public get isStatusWhatsappReady(): boolean {
    return this.data.status === AddReferralStatuses.WHATSAPP_READY;
  }
  public get isStatusPendingApproval(): boolean {
    return this.data.status === AddReferralStatuses.PENDING_APPROVAL;
  }
  public get isTrackableStatus(): boolean {
    return this.isStatusInvited || this.isStatusWhatsappReady || this.isStatusPendingApproval;
  }
  public get isStatusInvalidPhone(): boolean {
    return this.data.status === AddReferralStatuses.INVALIDPHONE;
  }
  public get isStatusAlreadyRegistered(): boolean {
    return this.data.status === AddReferralStatuses.ALREADYREGISTERED;
  }
  public get isStatusInvitationAlreadySent(): boolean {
    return this.data.status === AddReferralStatuses.INVITATION_ALREADY_SENT;
  }

  public isUserTypeSpecial = computed<boolean>(() => {
    const specialUserTypes: UserTypes[] = [UserTypes.RE, UserTypes.AY, UserTypes.CO, UserTypes.PA, UserTypes.PR];
    return specialUserTypes.includes(this.data?.userType);
  });

  public get isGanasocios() {
    return this.data?.userType === UserTypes.PR;
  }

  constructor(
    @Inject(NZ_MODAL_DATA) public data: IValidateReferralStatusData,
    public translateService: TranslateService,
    private _router: Router,
    private _modal: NzModalRef,
    private _referralModalFacade: ReferralModalFacade,
    private _modalService: NzModalService
  ) {}

  public onTrackReferralClick(): void {
    const referralId: number = this.data?.referralData?.referral_id;
    this._router.navigate(['/workspace/my-referrals/referral/', referralId]);
    this._modal.destroy();
  }

  public onAddGanamigosClick(): void {
    /*const prefilledData = {
      phone_code: '+' + this.data?.referralData?.phone_code,
      phone_number: this.data?.referralData?.phone_number
    };
    this._modalService.create({
      nzContent: AddGanamigosModalComponent,
      nzCentered: true,
      nzWrapClassName: 'modal-wrap',
      nzWidth: 608,
      nzData: { prefilledData }
    });
    this._modal.destroy();*/
  }

  public onCancelClick(): void {
    this._modal.close(false);
  }

  public onTryAgainClick(): void {
    this._modal.destroy();
  }

  public onAddReferralClick(): void {
    this._modal.close();
    this._referralModalFacade.openAddReferralModal();
  }
}
